export type CustomerState = {
    rucHasLegalRepresentative: boolean;
    business: {
        name: string;
        ruc: string;
        payrollMonthlyAmount: number;
        numberOfWorkers: number;
        payrollPeriod: string;
        netRate: number;
    };
    contact: {
        name: string;
        phone: string;
        email: string;
    };
    naturalName: string;
    naturalLastName: string;
    naturalMotherLastName: string;
    isNaturalPerson: boolean;
};

export const customerDefaultState: CustomerState = {
    rucHasLegalRepresentative: false,
    business: {
        name: null,
        ruc: null,
        netRate: null,
        numberOfWorkers: null,
        payrollMonthlyAmount: null,
        payrollPeriod: null,
    },
    contact: {
        email: null,
        name: null,
        phone: null,
    },
    naturalName: null,
    naturalLastName: null,
    naturalMotherLastName: null,
    isNaturalPerson: false,
};
